
export function setPlan (state, data) {
    if (data) {
        state.plan = { ...data }
    } else {
        state.plan = null
    }
}
